import React from "react";
import BreadCrumbsPage from "../../components/BreadCrumbsPage";
import { Tab, Tabs } from "@nextui-org/react";
import EmissionInsight from "./EmissionInsight";
import DashboardCharts from "./DashboardCharts";

/**
 * Analytics Component
 * Main analytics dashboard for sustainability metrics and insights
 * Provides enterprise-level analytics for emissions, waste, and water usage
 * @returns {JSX.Element} Analytics dashboard with tabbed insights
 */
const Analytics = () => {
  // User and organization data from session storage
  const userLogged = JSON.parse(sessionStorage.getItem("userData"));
  const orgInfo = userLogged && userLogged.user.LastOrgId;



  return (
    <div className="min-h-screen bg-neutral-50">
      {/* Page Header */}
      <div className="bg-white border-b border-neutral-200 px-8 py-4 shadow-sm">
        <div className="max-w-full">
          <h1 className="text-xl font-semibold text-neutral-900">Sustainability Activities</h1>
          <p className="text-sm text-neutral-600 mt-1">Enterprise-level insights and analytics dashboard</p>
        </div>
      </div>

      <BreadCrumbsPage>
        <div className="max-w-7xl mx-auto px-8 py-8">
          {/* Overview Card */}
          <div className="bg-white rounded-lg border border-neutral-200 shadow-sm p-6 mb-8">
            <h2 className="text-lg font-semibold text-neutral-900 mb-3">Analytics Overview</h2>
            <p className="text-neutral-600 leading-relaxed">
              This dashboard provides enterprise-level insights into key
              sustainability metrics, including emissions, waste management, and
              water usage. By analyzing these data points, organizations can track
              their sustainability performance, identify areas for improvement, and
              ensure compliance with environmental regulations. These insights are
              critical for driving data-informed decisions and enhancing operational
              efficiency across all departments.
            </p>
          </div>

          {/* Analytics Content with Tabs */}
          <div className="bg-white rounded-lg border border-neutral-200 shadow-sm overflow-hidden">
            {/* Tab Header */}
            <div className="px-6 py-4 border-b border-neutral-200">
              <h3 className="text-lg font-semibold text-neutral-900">Insights Dashboard</h3>
              <p className="text-sm text-neutral-600 mt-1">Analyze sustainability metrics and performance</p>
            </div>
            
            {/* Tabbed Content */}
            <div className="p-6">
              <Tabs 
                variant="light"
                classNames={{
                  tabList: "gap-6 w-full relative rounded-none p-0 border-b border-divider",
                  cursor: "w-full bg-neutral-100",
                  tab: "max-w-fit px-0 h-12",
                  tabContent: "group-data-[selected=true]:text-neutral-900"
                }}
              >
                {/* Emissions Insight Tab */}
                <Tab key="emission-insight" title="Emissions Insight">
                  <div className="mt-6">
                    <EmissionInsight />
                  </div>
                </Tab>
                
                {/* Dashboard Charts Tab */}
                <Tab key="dashboard-charts" title="Dashboard Charts">
                  <div className="mt-6">
                    <DashboardCharts />
                  </div>
                </Tab>
                
                {/* TODO: Future tabs for additional insights */}
                {/* <Tab key="waste-insight" title="Waste Management Insight">
                  <WasteInsight />
                </Tab> */}
                {/* <Tab key="water-insight" title="Water Usage Insight">
                  <WaterInsight />
                </Tab> */}
              </Tabs>
            </div>
          </div>
        </div>
      </BreadCrumbsPage>
    </div>
  );
};

export default Analytics;
